import { platformApi } from "@/app/platform";

import type { PhoneCountry } from "../types";

import { PHONE_COUNTRIES } from "./phoneUtils";

export async function inferCountryFromLocale(): Promise<PhoneCountry> {
  try {
    const locale = await platformApi.getLocale();
    const explicitRegion = new Intl.Locale(locale).region;

    if (
      explicitRegion &&
      PHONE_COUNTRIES.includes(explicitRegion as PhoneCountry)
    ) {
      return explicitRegion as PhoneCountry;
    }
  } catch {
    return "IQ";
  }

  return "IQ";
}
